import { useEffect } from "react";
import Header from '../Component/Header';
import { Link } from 'react-router-dom';
import Footer from '../Component/Footer';
import LazyLoad from "react-lazyload";
const Gallery = () => {
  useEffect(() => {
    document.title = 'Gallery - St Peters Convent School Faridabad Haryana';
  }, []);
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li><Link to="/">Home</Link></li>
          <li>Gallery</li>
          <li>Gallery</li>
        </ul>
      </div>
      <div class="innersec">
        <div class="container">
          <div class="row g-3">
            <div class="col-lg-12">
              <h1>Gallery</h1>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6">
              <a href="/PhotoGallery" class="gallery-item">
                <div class="card">
                  <LazyLoad>
                    <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/PhotoGallery.jpg" className="card-img-top img-fluid" alt="STPCSH" />
                  </LazyLoad>
                  <div class="card-body text-center">
                    <h5 class="card-title">Photo Gallery</h5>
                  </div>
                </div>
              </a>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6">
              <a href="/OutReachProgram" class="gallery-item">
                <div class="card">
                  <LazyLoad>
                    <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/SocialOutreach.jpg" className="card-img-top img-fluid" alt="STPCSH" />
                  </LazyLoad>
                  <div class="card-body text-center">
                    <h5 class="card-title">Social Outreach</h5>
                  </div>
                </div>
              </a>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6">
              <a href="/EcoClub" class="gallery-item">
                <div class="card">
                  <LazyLoad>
                    <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/EcoClub.jpg" className="card-img-top img-fluid" alt="STPCSH" />
                  </LazyLoad>
                  <div class="card-body text-center">
                    <h5 class="card-title">Eco Club</h5>
                  </div>
                </div>
              </a>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6">
              <a href="/Assemblies" class="gallery-item">
                <div class="card">
                  <LazyLoad>
                    <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/Assemblies.jpg" className="card-img-top img-fluid" alt="STPCSH" />
                  </LazyLoad>
                  <div class="card-body text-center">
                    <h5 class="card-title">Assemblies</h5>
                  </div>
                </div>
              </a>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6">
              <a href="/Activity" class="gallery-item">
                <div class="card">
                  <LazyLoad>
                    <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/AcademicActivities.jpg" className="card-img-top img-fluid" alt="STPCSH" />
                  </LazyLoad>
                  <div class="card-body text-center">
                    <h5 class="card-title">Academic Activities</h5>
                  </div>
                </div>
              </a>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6">
              <a href="/CoCurricular" class="gallery-item">
                <div class="card">
                  <LazyLoad>
                    <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/Co-Curricular.jpg" className="card-img-top img-fluid" alt="STPCSH" />
                  </LazyLoad>
                  <div class="card-body text-center">
                    <h5 class="card-title">Co-Curricular</h5>
                  </div>
                </div>
              </a>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6">
              <a href="/Picnic" class="gallery-item">
                <div class="card">
                  <LazyLoad>
                    <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/Picnic.jpg" className="card-img-top img-fluid" alt="STPCSH" />
                  </LazyLoad>
                  <div class="card-body text-center">
                    <h5 class="card-title">Picnic</h5>
                  </div>
                </div>
              </a>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6">
              <a href="/CPD" class="gallery-item">
                <div class="card">
                  <LazyLoad>
                    <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/CPD.jpg" className="card-img-top img-fluid" alt="STPCSH" />
                  </LazyLoad>
                  <div class="card-body text-center">
                    <h5 class="card-title">CPD</h5>
                  </div>
                </div>
              </a>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6">
              <a href="/Celebrations" class="gallery-item">
                <div class="card">
                  <LazyLoad>
                    <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/Celebrations.jpg" className="card-img-top img-fluid" alt="STPCSH" />
                  </LazyLoad>
                  <div class="card-body text-center">
                    <h5 class="card-title">Celebrations</h5>
                  </div>
                </div>
              </a>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6">
              <a href="/ArtFest" class="gallery-item">
                <div class="card">
                  <LazyLoad>
                    <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/ArtFest.jpg" className="card-img-top img-fluid" alt="STPCSH" />
                  </LazyLoad>
                  <div class="card-body text-center">
                    <h5 class="card-title">Art Fest</h5>
                  </div>
                </div>
              </a>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6">
              <a href="/Exhibition" class="gallery-item">
                <div class="card">
                  <LazyLoad>
                    <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/Exhibition.jpg" className="card-img-top img-fluid" alt="STPCSH" />
                  </LazyLoad>
                  <div class="card-body text-center">
                    <h5 class="card-title">Exhibition</h5>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Gallery;
